import { MainTitle } from 'common/text';
import { Content } from 'common/containers';
import ExpensesTable from 'components/tables/expenses';
import AddButton from 'common/buttons/add';

const Expenses = () => {
	return (
		<>
			<MainTitle>
				<h1>Gastos</h1>
				<AddButton url={`/expenses/add`} />
			</MainTitle>
			<Content>
				<ExpensesTable />
			</Content>
		</>
	);
};
export default Expenses;
